<template>
  <div class="friends-container">
    <div
      v-for="friend in friends"
      :key="friend.steamid"
      class="friend-container"
    >
      <Friend :friend="friend" @addFriend="addFriend" />
    </div>
  </div>
</template>

<script>
import Friend from "./Friend.vue";

export default {
  name: "Friends",
  components: {
    Friend,
  },
  props: {
    friends: {
      type: Array,
      default: null,
    },
  },
  methods: {
    addFriend: function (value) {
      this.$emit("addFriend", value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.friends-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>